import axios from 'axios'
import lsProxy from './lsUtil'
const HttpUtil = {}

// 创建axios实例
const axiosInstance = axios.create({
  timeout: process.env.VUE_APP_DEFAULT_TIMEOUT, // 请求超时时间
  headers: {
    'Content-Type': 'application/json',
    // 其他默认headers
  }
})
// 请求拦截器
axiosInstance.interceptors.request.use(
  config => {
    // 检查header中是否已有token
    if (!config.headers['Authorization']) {
      // 从存储中获取token（可以是localStorage、Vuex等）
      let access = lsProxy.access;
      // 如果存在token则设置到header中
      if (access) {
        config.headers['Authorization'] = `Bearer ${access.token}`
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
HttpUtil.install = (Vue) => {
    Vue.prototype.sendGet = (url, params, timeout = axiosInstance.defaults.timeout) => {
        const config = {
            params,
            timeout
        };

        if (params) {
            return axiosInstance.get(url, config);
        } else {
            return axios.get(url, { timeout });
        }
    }

    Vue.prototype.sendPost = (url, params, timeout = axiosInstance.defaults.timeout) => {
        return axiosInstance.post(url, params, {
            timeout
        })
    }

    Vue.prototype.setAuth = () => {
        let access = lsProxy.access;
        axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + (access ? access.token : '');
    }
    Vue.prototype.download = (url, params, timeout = 300000) => {
      return axiosInstance.post(url, {
            ...params,
        },{
          responseType: 'blob',
          timeout
        })
    }
}

export default HttpUtil


// WEBPACK FOOTER //
// ./src/utils/httpUtil.js